import { useRef } from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { TESTIMONIALS, SITE } from "@/lib/site";

export default function Testimonials() {
  const track = useRef(null);
  return (
    <section className="relative py-24 sm:py-32 bg-ink-900 border-y border-white/5 overflow-hidden" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <p className="overline mb-4">5-Star, for real</p>
            <h2 className="font-display font-extrabold text-4xl sm:text-5xl tracking-tighter text-white leading-[0.95]">
              Neighbors who<br />love their internet.
            </h2>
          </div>
          <a href={SITE.social.google} target="_blank" rel="noreferrer" className="text-cyan-400 font-mono-tech text-sm hover:text-white transition-colors shrink-0" data-testid="google-reviews-link">
            Read more on Google →
          </a>
        </Reveal>
      </div>

      <Reveal>
        <motion.div ref={track} className="cursor-grab active:cursor-grabbing pl-5 sm:pl-8">
          <motion.div
            drag="x"
            dragConstraints={{ left: -(TESTIMONIALS.length * 400), right: 0 }}
            className="flex gap-5"
          >
            {TESTIMONIALS.map((t) => (
              <div key={t.name} className="w-[300px] sm:w-[380px] shrink-0 bg-ink-950 border border-white/10 rounded-2xl p-8 select-none">
                <Quote size={28} className="text-cyan-500/40 mb-4" />
                <div className="flex gap-1 mb-4">
                  {[...Array(5)].map((_, i) => <Star key={i} size={15} className="fill-cyan-400 text-cyan-400" />)}
                </div>
                <p className="text-zinc-300 text-[15px] leading-relaxed mb-6">{t.text}</p>
                <div className="font-display font-bold text-white">{t.name}</div>
              </div>
            ))}
          </motion.div>
        </motion.div>
      </Reveal>
      <p className="max-w-7xl mx-auto px-5 sm:px-8 mt-6 text-xs text-zinc-500 font-mono-tech">← Drag to explore reviews</p>
    </section>
  );
}
